export const DataService = {
  /**
   *
   * @param {object} params
   * @param {funtion} callback
   */
  getData: function(params, callback) {
    let parameter = "";
    if (params) {
      parameter = params.query ? "?querys=" + params.query : "?noquery=0";
      let ubigeo = params.ubigeo;
      if (ubigeo && ubigeo !== "00") {
        ubigeo = ubigeo.padEnd(6, "0");
        parameter += `&ubigeo=${ubigeo}`;
      }
      parameter += params.marco ? "&marco=" + params.marco : "";
      parameter += params.periodo ? "&periodo=" + params.periodo : "";
      parameter += params.pnum != null ? "&pnum=" + params.pnum : "";
      parameter += params.psize != null ? "&psize=" + params.psize : "";
      parameter += params.q1 != null ? "&q1=" + params.q1 : "";
      parameter += params.q2 != null ? "&q2=" + params.q2 : "";
      parameter += params.q3 != null ? "&q3=" + params.q3 : "";
      parameter += params.serie != null ? "&serie=" + params.serie : "";
    }
    fetch(window.Config.API_URL + parameter)
      .then(res => res.json())
      .then(
        result => {
          if (result.success) {
            callback(result);
          }
        },
        error => {
        }
      );
  },
  getData2: function(params) {
    // query param
    if (params.query) {
      params.querys = params.query;
      delete params.query;
    } else {
      params.noquery = "0";
    }
    // Fix ubigeo
    let ubigeo = params.ubigeo;
    if (ubigeo && ubigeo !== "00") {
      params.ubigeo = ubigeo.padEnd(6, "0");
    }
    let arrayParams = [];
    for (const key in params) {
      arrayParams.push(`${key}=${params[key]}`);
    }
    let url = window.Config.API_URL + "?" + arrayParams.join("&");
    return fetch(url).then(
      result => result.json(),
      error => {
        // eslint-disable-next-line no-console
      }
    );
  }
};
